import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { POLITICA_ENTREGA_COLUMN_KEYS, PoliticaEntregaColumnKey } from '../../../models/politica-entrega.model';
import { PoliticaEntregaCellVm, PoliticaEntregaRowVm } from '../../../models/politica-entrega.vm';

@Component({
  selector: 'app-cemento-admin-matrix-table',
  templateUrl: './cemento-admin-matrix-table.component.html',
  styleUrls: ['./cemento-admin-matrix-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CementoAdminMatrixTableComponent {
  /** Estilos globales en styles.css (tokens, thead, chips). */
  @HostBinding('class.cbb-admin-matrix-table') readonly hostMatrixTableClass = true;

  @Input() rows: readonly PoliticaEntregaRowVm[] = [];
  @Output() cellSelected = new EventEmitter<PoliticaEntregaCellVm>();

  readonly columnKeys = POLITICA_ENTREGA_COLUMN_KEYS;

  columnLabel(key: PoliticaEntregaColumnKey): string {
    return key.replace('col', '');
  }

  trackByRow(_: number, row: PoliticaEntregaRowVm): string {
    return row.trackId;
  }

  trackByColumn(_: number, key: PoliticaEntregaColumnKey): PoliticaEntregaColumnKey {
    return key;
  }

  trackByCell(_: number, cell: PoliticaEntregaCellVm): string {
    return cell.trackId;
  }

  onCellSelected(cell: PoliticaEntregaCellVm): void {
    this.cellSelected.emit(cell);
  }
}
